import config from "src/config";
import http, { postWithBasicHeader } from "../services/apiServices";
import { isCivilDefenseUser } from "src/utils/helpers";

export const getMaintenanceAppointmentsStatisticsApi = async (Dashboard: any
) => {
  const api = isCivilDefenseUser() ? config.CivilDefense.maintenanceAppointmentsStatistics : config.BMCCompany.maintenanceAppointmentsStatistics
  return await http.post(api, Dashboard
  );
};
export const getMaintenanceRequestsStatisticsApi = async (Dashboard: any) => {
  const api = isCivilDefenseUser() ? config.CivilDefense.maintenanceRequestsStatistics : config.BMCCompany.maintenanceRequestsStatistics
  return await http.post(api, Dashboard
  );
};
export const getATECasesStatisticsApi = async (Dashboard: any) => {
  const api = isCivilDefenseUser() ? config.CivilDefense.ateCasesStatistics : config.BMCCompany.ateCasesStatistics
  return await http.post(api, Dashboard
  );
};

export const getBMCRatingStatisticsAPI = async (Dashboard: any) => {
  const api = config.CivilDefense.bmcRatingStatistics ;
  return await http.post(api, Dashboard
  );
};

export const getContractInformationStatisticsApi = async (Dashboard: any) => {
  const api = isCivilDefenseUser() ? config.CivilDefense.contractInformationStatistics : config.BMCCompany.contractInformationStatistics
  return await http.post(api, Dashboard
  );
};

export const getDashboardCardsApi = async (data: any) => {
  const api = isCivilDefenseUser() ? config.CivilDefense.dashboardCards : config.BMCCompany.dashboardCards
  return await http.post(api, data);
};

export const getBuildingsStatisticsApi = async (data: any) => {
  const api = isCivilDefenseUser() ? config.CivilDefense.buildingsStatistics : config.BMCCompany.buildingsStatistics
  return await http.post(api, data);
};
